import common from "../common";
import {saveAs} from "file-saver";

export function fetchSlotJson(key) {
    return common.tempLoader.resources[key].data;
}

export function fetchSpineData(key) {
    return common.tempLoader.resources[key].spineData;
}

/**
 * Rounds a point
 * @param point
 * @returns {PIXI.Point}
 */
export function roundPoint(point) {
    point.x = Math.round(point.x);
    point.y = Math.round(point.y);
    return point;
}

/**
 * Displays numbers as pounds and pence
 * @param number
 * @returns {string}
 */
export function displayCurrency(number) {
    /*
    if (number < 1) {
        return DecisionData.floatToPence(number);
    } else {

     */
    const dCount = decimalCount(number);
    if (dCount > 0 && dCount < 2)
        return "£" + number.toString() + "0";
    else
        return "£" + number.toString();
    //}
}

/**
 * Returns translated string for given key
 * @param key
 * @param strings
 * @returns {string}
 */
export function translate(key, strings = common.strings) {
    let str = key || "";
    if (str.length > 0) {
        const split = str.split(".");
        split.push(window.__language ? window.__language : common.config.language);
        let i, length, t = strings;
        for (i = 0, length = split.length; i < length; ++i) {
            t = t[split[i]];
            if (!t) break;
        }
        i === split.length && (str = t);
    }
    return str;
}

// from https://stackoverflow.com/questions/17369098/simplest-way-of-getting-the-number-of-decimals-in-a-number-in-javascript
export function decimalCount(value) {
    if (Math.floor(value.valueOf()) === value.valueOf()) return 0;
    return value.toString().split(".")[1].length || 0;
}

/**
 *
 * @param texture 
 * @param callback
 */
export function saveImage(texture, callback) {
    // Dev Note: As of recently.. saveImageToDevice seems to cause cross origin issues on CN's site. 
    // so we are forcing the alternative save method which uses file-saver
    // --
    // if (window.parent && window.parent.saveImageToDevice) {
    //     const data = common.renderer.plugins.extract.base64(texture);
    //     window.parent.saveImageToDevice(data, callback, (error) => console.error(error));
    // } else {}
    // --

    const data = common.renderer.plugins.extract.canvas(texture);
    data.toBlob(function (blob) {
        saveAs(blob, "screenshot.png");
    }, "image/png");
    callback && callback.call();
}

/**
 * http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
 * @returns {string}
 */
export function randomSeed() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

/**
 * @returns {boolean}
 */
export function isCordova() {
    return !!window.cordova;
}

/**
 * @returns {number}
 */
export function calcLeftEdge() {
    return (common.STAGE_WIDTH - P3.View.width) * 0.5;
}

/**
 * @returns {number}
 */
export function calcRightEdge() {
    return (common.STAGE_WIDTH + P3.View.width) * 0.5;
}

/**
 * saves to device storage
 * @param image
 */
export function saveToFileSystem(image) {
    const data = common.renderer.plugins.extract.base64(image, "image/png");

    // todo - tidy up below splits
    // Split the base64 string in data and contentType
    var block = data.split(";");
    // Get the content type
    var dataType = block[0].split(":")[1];// In this case "image/png"
    // get the real base64 content of the file
    var realData = block[1].split(",")[1];// In this case "iVBORw0KGg...."

    const fileName = common.config.save.name + "-" + Date.now() + "-" + common.config.save.app_hash;

    const arrayBuffer = base64ToArrayBuffer(realData);

    let storageLocation = "";
    if (PIXI.utils.isMobile.android.device) {
        storageLocation = "file:///storage/emulated/0/Download";
    } else {
        storageLocation = cordova.file.documentsDirectory;
    }

    window.resolveLocalFileSystemURL(storageLocation, (entry) => {
        saveFile(entry, arrayBuffer, fileName + ".png");
    }, (err) => {
        console.log(err);
    });

    function writeFile(fileEntry, dataObj, callback) {
        // Create a FileWriter object for our FileEntry (log.txt).
        fileEntry.createWriter(function (fileWriter) {

            fileWriter.onwriteend = function () {
                console.log("Successful file write...");
                callback && callback.call();
            };

            fileWriter.onerror = function (e) {
                console.log("Failed file write: " + e.toString());
            };

            fileWriter.write(dataObj);
        });
    }

    function saveFile(dirEntry, fileData, fileName) {
        dirEntry.getFile(fileName, {create: true, exclusive: false}, function (fileEntry) {

            writeFile(fileEntry, fileData);

        }, (err) => {
            console.log(err);
        });
    }
}

export function base64ToArrayBuffer(base64) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

//array fill polyfill
(function () {
    if (!Array.prototype.fill) {
        Object.defineProperty(Array.prototype, 'fill', {
            value: function (value) {

                // Steps 1-2.
                if (this == null) {
                    throw new TypeError('this is null or not defined');
                }

                var O = Object(this);

                // Steps 3-5.
                var len = O.length >>> 0;

                // Steps 6-7.
                var start = arguments[1];
                var relativeStart = start >> 0;

                // Step 8.
                var k = relativeStart < 0 ?
                    Math.max(len + relativeStart, 0) :
                    Math.min(relativeStart, len);

                // Steps 9-10.
                var end = arguments[2];
                var relativeEnd = end === undefined ?
                    len : end >> 0;

                // Step 11.
                var finalValue = relativeEnd < 0 ?
                    Math.max(len + relativeEnd, 0) :
                    Math.min(relativeEnd, len);

                // Step 12.
                while (k < finalValue) {
                    O[k] = value;
                    k++;
                }

                // Step 13.
                return O;
            }
        });
    }

})();

// array flat polyfill from - https://codepen.io/chungguo/pen/xvXeMR
(function () {
    if (!Array.prototype.flat) {
        Object.defineProperty(Array.prototype, 'flat', {
            value: function () {
                return this.reduce((acc, cur, index) => {
                    return Array.isArray(cur) ? acc.concat(flat(cur)) : acc.concat(cur);
                }, []);
            }
        });
    }
})();

(function () {
    P3.Button.prototype.onMouseDown = function (event) {
        this._states.down && (this._background.texture = this._currentDownTexture);
        this._states.iconDown && (this._icon.texture = this._currentIconDownTexture);

        if (this.animate) {
            this.stopAnimations();
            this._tweens.down = this.animateDown();
        }

        if (this._enabled) {
            this.downSoundName && P3.audio.playOneShot(this.downSoundName);
            this.signals.down.dispatch(this, event);
        }
    }
    P3.Button.prototype.onMouseClick = function (event) {
        if (this._enabled) {
            this.clickSoundName && P3.audio.playOneShot(this.clickSoundName);
            this.signals.click.dispatch(this, event);
        }
    }
})();

// fixing bug with animated sprite
(function () {
    /**
     * @param deltaTime
     */
    PIXI.AnimatedSprite.prototype.update = function (deltaTime) {
        if (!this._playing)
            return;

        const elapsed = this.animationSpeed * deltaTime;
        const previousFrame = this.currentFrame;
        if (this._durations !== null) {
            let lag = this._currentTime % 1 * this._durations[this.currentFrame];
            lag += elapsed / 60 * 1000;
            while (lag < 0) {
                this._currentTime--;
                lag += this._durations[this.currentFrame];
            }
            const sign = Math.sign(this.animationSpeed * deltaTime);
            this._currentTime = Math.floor(this._currentTime);
            while (lag >= this._durations[this.currentFrame]) {
                lag -= this._durations[this.currentFrame] * sign;
                this._currentTime += sign;
            }
            this._currentTime += lag / this._durations[this.currentFrame];
        } else {
            this._currentTime += elapsed;
        }
        if (this._currentTime < 0 && !this.loop) {
            this.gotoAndStop(0);
            if (this.onComplete) {
                this.onComplete();
            }
        } else if (this._currentTime >= this._textures.length && !this.loop) {
            this.gotoAndStop(this._textures.length - 1);
            if (this.onComplete) {
                this.onComplete();
            }
        } else if (previousFrame !== this.currentFrame) {
            if (this.loop && this.onLoop) {
                if (this.animationSpeed > 0 && this.currentFrame < previousFrame) {
                    this.onLoop();
                } else if (this.animationSpeed < 0 && this.currentFrame > previousFrame) {
                    this.onLoop();
                }
            }
            this.updateTexture();
        }
    }
})();

(function () {
    P3.Camera.prototype.update = function () {

        this._target && this._position.set(this._target.x * this._parallax.x, this._target.y * this._parallax.y);
        this._clampToBounds(this._position);

        for (let i = 0; i < this._layers.length; ++i) {
            const layer = this._layers[i];
            const position = new PIXI.Point(this._target.x * layer.parallax.x, this._target.y * layer.parallax.y);
            layer.view.pivot.set(this.focus.x + position.x, this.focus.y + position.y);
            layer.view.position.set(layer.view.pivot.x + this.offset.x + (this._position.x * -layer.parallax.x),
                layer.view.pivot.y + this.offset.y + (this._position.y * -layer.parallax.y));
            layer.view.scale.set(this.zoom, this.zoom);
        }

    }
})();

(function () {
    /**
     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
     * order, with integer values between 0 and 255 (included).
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use the main renderer
     * @return {Uint8Array} One-dimensional array containing the pixel data of the entire texture
     */

    PIXI.Extract.prototype.pixel = function (target, point) {

        const renderer = this.renderer;
        let resolution;
        let frame;
        let renderTexture;
        let generated = false;
        if (target) {
            if (target instanceof PIXI.RenderTexture) {
                renderTexture = target;
            } else {
                renderTexture = this.renderer.generateTexture(target);
                generated = true;
            }
        }
        if (renderTexture) {
            resolution = renderTexture.baseTexture.resolution;
            frame = renderTexture.frame;
            // bind the buffer
            renderer.renderTexture.bind(renderTexture);
        } else {
            resolution = renderer.resolution;
            frame = TEMP_RECT;
            frame.width = renderer.width;
            frame.height = renderer.height;
            renderer.renderTexture.bind(null);
        }
        const width = frame.width * resolution;
        const height = frame.height * resolution;
        const webglPixels = new Uint8Array(4);
        // read pixels to the array
        const gl = renderer.gl;
        gl.readPixels(point.x * resolution, point.y * resolution, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
        if (generated) {
            renderTexture.destroy(true);
        }
        PIXI.Extract.arrayPostDivide(webglPixels, webglPixels);
        return webglPixels;

    }
})();

(function () {
    const tempPoint = new PIXI.Point();
    PIXI.Sprite.prototype.getColorByPoint = function (point) {
        this.worldTransform.applyInverse(point, tempPoint);

        const width = this._texture.orig.width;
        const height = this._texture.orig.height;
        const x1 = -width * this.anchor.x;
        let y1 = 0;

        let flag = false;

        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
            y1 = -height * this.anchor.y;

            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
                flag = true;
            }
        }

        if (!flag) {
            return [0, 0, 0, 0];
        }

        // bitmap check

        const tex = this.texture;
        const baseTex = this.texture.baseTexture;
        if (!baseTex.colormap) {
            if (!genColorMap(baseTex)) {
                return [0, 0, 0, 0];
            }
        }

        const colormap = baseTex.colormap;
        const data = colormap.data;
        const res = baseTex.resolution;
        // this does not account for rotation yet!!!
        let dx = Math.round((tempPoint.x - x1 + tex.frame.x) * res);
        let dy = Math.round((tempPoint.y - y1 + tex.frame.y) * res);
        let num = dx + dy * colormap.width;
        return [data[num * 4], data[num * 4 + 1], data[num * 4 + 2], data[num * 4 + 3]];

        function genColorMap(baseTex) {
            if (!baseTex.resource) {
                //renderTexture
                return false;
            }
            const imgSource = baseTex.resource.source;
            // console.log(imgSource);
            let canvas = null;
            if (!imgSource) {
                return false;
            }
            let context = null;
            if (imgSource.getContext) {
                canvas = imgSource;
                context = canvas.getContext('2d');
                //console.log(context);
            }

            const w = canvas.width, h = canvas.height;
            baseTex.colormap = context.getImageData(0, 0, w, h);
            return true;
        }
    }
})();

/*
(function () {
    P3.utils.TWEEN.Group.prototype.time = 0;
    P3.utils.TWEEN.Group.prototype.update = function (time, preserve) {
        this.time += window.tweendt;

        var tweenIds = Object.keys(this._tweens);
        if (tweenIds.length === 0) {
            return false;
        }
        time = time !== undefined ? time : this.time;
        while (tweenIds.length > 0) {
            this._tweensAddedDuringUpdate = {};

            for (var i = 0; i < tweenIds.length; i++) {
                var tween = this._tweens[tweenIds[i]];
                if (tween && tween.update(time) === false) {
                    tween._isPlaying = false;
                    if (!preserve) {
                        delete this._tweens[tweenIds[i]];
                    }
                }
            }
            tweenIds = Object.keys(this._tweensAddedDuringUpdate);
        }

        return true;
    };

    P3.utils.TWEEN.Tween.prototype.start = function (time) {
        this._group.add(this);

        this._isPlaying = true;

        this._onStartCallbackFired = false;

        this._startTime = time !== undefined ? typeof time === 'string' ? this._group.time + parseFloat(time) : time : this._group.time;
        this._startTime += this._delayTime;

        for (var property in this._valuesEnd) {
            if (this._valuesEnd[property] instanceof Array) {
                if (this._valuesEnd[property].length === 0) {
                    continue;
                }
                this._valuesEnd[property] = [this._object[property]].concat(this._valuesEnd[property]);

            }
            if (this._object[property] === undefined) {
                continue;
            }

            this._valuesStart[property] = this._object[property];

            if ((this._valuesStart[property] instanceof Array) === false) {
                this._valuesStart[property] *= 1.0;
            }
            this._valuesStartRepeat[property] = this._valuesStart[property] || 0;
        }

        return this;
    };
})();
 */